// removed by extract-text-webpack-plugin
module.exports = {"EquipmentItem":"EquipmentItem","EquipmentItem__image":"EquipmentItem__image","EquipmentItem__heading":"EquipmentItem__heading","EquipmentItem__detail":"EquipmentItem__detail","EquipmentItem__detail__link":"EquipmentItem__detail__link"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/equipment-item/styles.css
// module id = 841
// module chunks = 0 1